module.exports = __webpack_public_path__ + "static/media/ahead-logo.ff15bd24.svg";